import React, { Component } from 'react';

import './DataDumps.css';
import SectionTitle from './SectionTitle';
import ExternalLink from './ExternalLink';

class DataDumps extends Component {
  render() {
    return (
      <div id="lp-data-dumps" className="lp-data-dumps-container">
        <SectionTitle section="data-dumps" text="Data Dumps" />
        <div className="lp-text-description">
          The ImproveOSM data about missing roads, turn restrictions and missing one-ways is also available as a CSV download. You can find weekly dumps and metadata.
        </div>
        <ExternalLink data={{
          name: 'Download Data',
          url: 'https://dumps.improveosm.org/',
          gaMessage: 'a link from the data dumps section',
        }} isCentered={true} />
      </div>
    );
  }
}

export default DataDumps;



// WEBPACK FOOTER //
// ./src/components/DataDumps.js